import styled from 'styled-components';

export const PlayersList = styled.div`
    width: 100%;
    flex: 1;
    color: #fff;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
`;

export const Title = styled.div`
    width: 100%;
    text-transform: uppercase;
    font-size: 12px;
    color: #999;
    padding: 20px 0;
`;

export const Section = styled.div`
    width: 100%;
    text-transform: uppercase;
    font-size: 12px;
    color: #999;
    padding: 0 0 5px;
`;

export const Player = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    opacity: 0.2;

    &.online {
        opacity: 1;
    }

    &:hover {
        opacity: 1;
        background-color: #333;
    }

    &:not(.selected):not(.online):hover :not(.removePlayer){
        opacity: 0.2;
    }

    &.selected {
        opacity: 1;
        background-color: #444;
    }
`;

export const PlayerPhoto = styled.div`
    width: 30px;
    height: 30px;
    color: #000;
    background-color: ${props => props.color};
    margin-right: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-weight: 900;
`;

export const PlayerName = styled.div`
    flex: 1;
    font-size: 12px;
    color: ${props => props.color};
    font-weight: 900;
`;

export const PlayerAdd = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: stretch;
`;

export const PlayerEmailInput = styled.input`
    background-color: #222;
    margin-left: 5px;
    height: 30px;
    border: 1px solid #444;
    padding-left: 3px;
    width: 135px;
    color: #fff;
    margin-bottom: 10px;

    :focus {
        outline.color: ${props => props.theme.colors.main};
    }
`;

export const PlayerEmailSend = styled.div`
    height: 30px;
    width: 30px;
    min-width: 30px;
    margin: 0 5px;
    border: 1px solid #444;
    position: relative;

    &:before {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 14px;
        content: '\\F048A';
        font-family: "Material Design Icons";
    }
`;

export const Separator = styled.div`
    padding: 0 10px;
    height: 30px;
    color: #777;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`;

export const TableCode = styled.input`
    background-color: #222;
    height: 30px;
    border: 1px solid #444;
    padding-left: 10px;
    width: 135px;
    color: #fda;
    font-size: 14px;
    margin-bottom: 10px;
    margin-right: 10px;

    :focus {
        outline.color: ${props => props.theme.colors.main};
    }
`;

export const PlayerRemove = styled.div`
    width: 20px;
    height: 20px;
    margin-right: 20px;
    cursor: pointer;
    display: none;
    position: relative;

    &:before {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 18px;
        content: '\\F0156';
        font-family: "Material Design Icons";
    }

    .selected > & {
        display: block;
    }
`;

export const Button = styled.div`
    border: 1px solid ${props => props.color};
    color: ${props => props.color};
    padding: 0 15px;
    height: 30px;
    min-height: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: color .3s ease 0s, background-color .3s ease 0s;

    :hover {
        color: ${props => props.hoverColor || '#fff' };
        background-color: ${props => props.color};
    }

    &:not(:last-child) {
        margin-right: 10px;
    }
`;

export const ButtonRefresh = styled.div`
    border: 1px solid ${props => props.color};
    color: ${props => props.color};
    height: 30px;
    min-height: 30px;
    width: 30px;
    min-width: 30px;
    position: relative;
    cursor: pointer;
    transition: color .3s ease 0s, background-color .3s ease 0s;
    
    &:before {
        content: '\\F0450';
        size: 12px;
        font-family: "Material Design Icons";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }
    
    :hover {
        color: ${props => props.hoverColor || '#fff' };
        background-color: ${props => props.color};
    }
    
    &:not(:last-child) {
        margin-right: 10px;
    }
`;

export const NoParticipants = styled.div`
    flex: 1;
    width: 100%;
    color: #666;
    text-align: center;
    padding: 0 80px;
    line-height: 25px;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &:before {
        font-family: 'Material Design Icons';
        font-size: 150px;
        color: #333;
        content: '\\F0849';
        margin-bottom: 80px;
    }
    
`;